// Mock table rows, not a response from a live API. Keep snake_case aligned with PostgreSQL.
const id = value => `00000000-0000-4000-8000-${String(value).padStart(12, '0')}`;
const audit = {
    is_active: true,
    created_by: null,
    created_date: '2026-09-08T09:00:00',
    updated_by: null,
    updated_date: null,
    deleted_by: null,
    deleted_date: null,
};

export const backendSampleData = {
    m_org: [{
        ...audit, org_id: id(1), org_code: 'WELYA', org_name: 'Welya Indonesia',
        org_address: 'Jakarta, Indonesia', org_contact_person: 'Company Administrator',
        org_contact_no: '+62215550100', org_efficiency_factor: 95.00,
    }],
    m_division: [
        { ...audit, div_id: id(10), org_id: id(1), div_code: 'ENG', div_name: 'Engineering' },
        { ...audit, div_id: id(20), org_id: id(1), div_code: 'OPS', div_name: 'Operations' },
    ],
    m_department: [
        { ...audit, dept_id: id(11), div_id: id(10), dept_code: 'FE', dept_name: 'Frontend Development' },
        { ...audit, dept_id: id(12), div_id: id(10), dept_code: 'BE', dept_name: 'Backend Development' },
        { ...audit, dept_id: id(21), div_id: id(20), dept_code: 'PROJECT', dept_name: 'Project Delivery' },
    ],
    m_position: [
        { ...audit, pos_id: id(101), div_id: id(10), dept_id: null, pos_code: 'ENG-MGR', pos_name: 'Engineering Manager', pos_resource_total: 1 },
        { ...audit, pos_id: id(102), div_id: id(10), dept_id: id(11), pos_code: 'FE-DEV', pos_name: 'Frontend Developer', pos_resource_total: 5 },
        { ...audit, pos_id: id(103), div_id: id(10), dept_id: id(12), pos_code: 'BE-DEV', pos_name: 'Backend Developer', pos_resource_total: 4 },
        { ...audit, pos_id: id(104), div_id: id(20), dept_id: id(21), pos_code: 'PM', pos_name: 'Project Manager', pos_resource_total: 2 },
        { ...audit, pos_id: id(105), div_id: id(20), dept_id: null, pos_code: 'OPS-ANL', pos_name: 'Operations Analyst', pos_resource_total: 0, is_active: false },
    ].map(position => ({ ...position, submission_user_id: null, reviewer_user_id: null, approver_user_id: null })),
};
